import { CounterType } from "definitions/counter-api";
import { PaymentSubscribeRequestDto } from "definitions/poizon-bff";

export interface SubscribeBaseConfig {
  rps: number;
  requests: number | null;
  withExport?: boolean;
}

export interface SubscribeBase {
  title: string;
  config: SubscribeBaseConfig;
  promotion?: boolean;
}

export const subFormDefaultValues: PaymentSubscribeRequestDto = {
  rps: 0.5,
  req: 10000,
  time: "30 days",
  type: CounterType.AllSourcesRequests,
};

export const BASE_SUBSCRIBES: SubscribeBase[] = [
  {
    title: "Пробная",
    config: {
      rps: 3,
      requests: 500,
      withExport: true,
    },
    promotion: true,
  },
  {
    title: "Базовая",
    config: {
      rps: 0.5,
      requests: 10000,
      withExport: false,
    },
  },
  {
    title: "Стандартная",
    config: {
      rps: 2,
      requests: 200000,
      withExport: true,
    },
  },
  {
    title: "Расширенная",
    config: {
      rps: 3,
      requests: 600000,
      withExport: true,
    },
  },
  {
    title: "Безлимитная",
    config: {
      rps: 0.5,
      requests: null,
      withExport: false,
    },
  },
];
